import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import MainContent from './components/MainContent';
import AboutSection from './components/AboutSection';
import CasesSection from './components/CasesSection';
import ContactSection from './components/ContactSection';
import VerificationGate from './components/VerificationGate';
import SiteAmbientGlow from './components/SiteAmbientGlow';

const ACCESS_STORAGE_KEY = 'portfolio_access_v2';

function App() {
  const userName = "Joshua Silva";
  const yearValue = "2025";
  const [currentSection, setCurrentSection] = useState('home');
  const [isUnlocked, setIsUnlocked] = useState(
    () => localStorage.getItem(ACCESS_STORAGE_KEY) === 'true'
  );
  const accessPassword = 'portfoliopass';

  useEffect(() => {
    // Drop legacy key from the old password-only gate so verification runs again.
    localStorage.removeItem('portfolio_unlocked');
  }, []);
  
  const handleSectionChange = (section: string) => {
    const target = document.getElementById(section);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setCurrentSection(section);
  };

  const handleUnlock = () => {
    setIsUnlocked(true);
    localStorage.setItem(ACCESS_STORAGE_KEY, 'true');
  };

  return (
    <div className={`app-container ${isUnlocked ? 'app-unlocked' : ''}`}>
      <SiteAmbientGlow />
      <div className={`password-gate ${isUnlocked ? 'gate-exit' : ''}`}>
        {!isUnlocked && (
          <VerificationGate accessPassword={accessPassword} onUnlock={handleUnlock} />
        )}
      </div>

      <div className={`main-stage ${isUnlocked ? 'main-stage--visible' : 'main-stage--locked'}`}>
        <Navbar onSectionChange={handleSectionChange} />

        <div id="home">
          <MainContent name={userName} year={yearValue} onNavigate={handleSectionChange} />
        </div>
        <div id="about">
          <AboutSection name={userName} year={yearValue} />
        </div>
        <div id="projects">
          <CasesSection />
        </div>
        <div id="contact">
          <ContactSection />
        </div>
      </div>
    </div>
  );
}

export default App;
